export default __webpack_public_path__ + "static/media/star.95333922.png";